module.exports = __webpack_public_path__ + "img/symbol_deleteyellow.46966737.png";